import React from 'react'
import {
  Path,
  G,
  Defs,
  LinearGradient,
  Stop,
  ClipPath,
  Rect,
  RadialGradient,
  Circle,
} from 'react-native-svg'

import { AccessibleSvg } from 'ui/svg/AccessibleSvg'
import { svgIdentifier } from 'ui/svg/utils'

import { AccessibleRectangleIcon } from '../types'

export const MuseumCulturalVisits: React.FunctionComponent<AccessibleRectangleIcon> = ({
  accessibilityLabel,
  testID,
  width = 156,
  height = 92,
}) => {
  const { id: gradientId, fill: gradientFill } = svgIdentifier()
  const { id: gradientId1, fill: gradientFill1 } = svgIdentifier()
  const { id: gradientId2, fill: gradientFill2 } = svgIdentifier()
  const { id: gradientId3, fill: gradientFill3 } = svgIdentifier()
  const { id: gradientId4, fill: gradientFill4 } = svgIdentifier()
  const { id: gradientId5, fill: gradientFill5 } = svgIdentifier()
  const { id: gradientId6, fill: gradientFill6 } = svgIdentifier()
  const { id: gradientId7, fill: gradientFill7 } = svgIdentifier()
  const { id: clipPathId, fill: clipPath } = svgIdentifier()

  return (
    <AccessibleSvg
      width={width}
      height={height}
      viewBox="0 0 156 92"
      fill="none"
      accessibilityLabel={accessibilityLabel}
      testID={testID}>
      <G clipPath={clipPath}>
        <Path
          d="M-7.7373 83.0723C-7.7373 81.4553 -6.42651 80.1445 -4.80957 80.1445H51.3245C52.9813 80.1445 54.3245 81.4877 54.3245 83.1445V86H-4.80957C-6.42651 86 -7.7373 84.6892 -7.7373 83.0723Z"
          fill="#94F0D6"
        />
        <G>
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M48.0078 52.3707C48.3284 51.1067 47.3732 49.8789 46.0692 49.8789H41.4904C40.1864 49.8789 39.2311 51.1067 39.5518 52.3707L40.4811 56.0342C40.5179 56.179 40.5699 56.3168 40.6353 56.446V79.6104C40.0724 79.9292 39.6772 80.5137 39.6253 81.2011L39.082 88.4016C38.9944 89.5622 39.9124 90.5521 41.0763 90.5521H46.4832C47.6471 90.5521 48.5652 89.5622 48.4776 88.4016L47.9342 81.2011C47.8823 80.5139 47.4874 79.9295 46.9248 79.6107V56.4449C46.9899 56.3161 47.0418 56.1786 47.0784 56.0342L48.0078 52.3707Z"
            fill={gradientFill}
          />
        </G>
        <G>
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M30.4257 52.3707C30.7464 51.1067 29.7911 49.8789 28.4871 49.8789H23.9083C22.6043 49.8789 21.6491 51.1067 21.9697 52.3707L22.8991 56.0342C22.9358 56.179 22.9879 56.3168 23.0532 56.446V79.6104C22.4904 79.9292 22.0952 80.5137 22.0433 81.2011L21.4999 88.4016C21.4123 89.5622 22.3304 90.5521 23.4943 90.5521H28.9012C30.0651 90.5521 30.9831 89.5622 30.8955 88.4016L30.3522 81.2011C30.3003 80.5139 29.9053 79.9295 29.3428 79.6107V56.4449C29.4079 56.3161 29.4597 56.1786 29.4964 56.0342L30.4257 52.3707Z"
            fill={gradientFill1}
          />
        </G>
        <G>
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.7011 52.3707C13.0218 51.1067 12.0665 49.8789 10.7625 49.8789H6.18373C4.87974 49.8789 3.9245 51.1067 4.24513 52.3707L5.17447 56.0342C5.21122 56.179 5.26327 56.3168 5.32863 56.446V79.6104C4.76577 79.9292 4.37057 80.5137 4.31869 81.2011L3.77532 88.4016C3.68773 89.5622 4.60578 90.5521 5.76965 90.5521H11.1766C12.3405 90.5521 13.2585 89.5622 13.1709 88.4016L12.6276 81.2011C12.5757 80.5139 12.1807 79.9295 11.6182 79.6107V56.4449C11.6833 56.3161 11.7351 56.1786 11.7718 56.0342L12.7011 52.3707Z"
            fill={gradientFill2}
          />
        </G>
        <Path
          d="M12.2276 52.5747C12.6126 51.2915 11.6517 50 10.3119 50H6.68806C5.34834 50 4.38744 51.2915 4.77241 52.5747L5.37241 54.5747C5.6262 55.4207 6.40484 56 7.28806 56H9.71194C10.5952 56 11.3738 55.4207 11.6276 54.5747L12.2276 52.5747Z"
          fill="#DBFFEA"
        />
        <Path
          d="M30.1225 52.6325C30.5542 51.3374 29.5903 50 28.2251 50H23.7749C22.4097 50 21.4458 51.3374 21.8775 52.6325L22.5442 54.6325C22.8164 55.4491 23.5807 56 24.4415 56H27.5585C28.4193 56 29.1836 55.4491 29.4558 54.6325L30.1225 52.6325Z"
          fill="#DBFFEA"
        />
        <Path
          d="M48.2276 52.5747C48.6126 51.2915 47.6517 50 46.3119 50H42.6881C41.3483 50 40.3874 51.2915 40.7724 52.5747L41.3724 54.5747C41.6262 55.4207 42.4048 56 43.2881 56H45.7119C46.5952 56 47.3738 55.4207 47.6276 54.5747L48.2276 52.5747Z"
          fill="#DBFFEA"
        />
        <G>
          <Path
            d="M50 51H-8.25073H-10C-12.2091 51 -14 49.2091 -14 47V25.1139C-14 23.9356 -13.4804 22.8171 -12.5799 22.0571L-0.407387 11.784C0.864624 10.7105 2.66848 10.5369 4.1219 11.3481L51.9494 38.042C53.2155 38.7486 54 40.0849 54 41.5348V47C54 49.2091 52.2091 51 50 51Z"
            fill={gradientFill3}
          />
        </G>
        <G>
          <Rect x={-1} y={83} width={61} height={8} rx={2} fill={gradientFill4} />
        </G>
        <Path
          d="M-1 90C-1 88.8954 -0.104569 88 1 88H63C64.1046 88 65 88.8954 65 90V91H-1V90Z"
          fill={gradientFill5}
        />
        <Circle
          cx={2.15039}
          cy={29.5}
          r={6}
          fill="#94F0D6"
          stroke={gradientFill6}
          strokeWidth={3}
        />
        <Path opacity={0.6} d="M3 83H13V88.0938H3V83Z" fill="#DBFFEA" />
        <Path d="M2 88.0938H11V91H2V88.0938Z" fill="#DBFFEA" />
        <Rect opacity={0.6} x={21} y={83} width={10} height={5.09375} fill="#DBFFEA" />
        <Rect x={20} y={88.0938} width={9} height={2.90625} fill="#DBFFEA" />
        <Rect opacity={0.6} x={38} y={83} width={10} height={5.09375} fill="#DBFFEA" />
        <Rect x={36} y={88.0938} width={10} height={2.90625} fill="#DBFFEA" />
        <Path d="M-1 48H54C54 49.6569 52.6569 51 51 51H-1V48Z" fill="#DBFFEA" />
        <Rect opacity={0.4} x={5.34961} y={56} width={1} height={24} fill="#DBFFEA" />
        <Rect opacity={0.4} x={23} y={56} width={1} height={24} fill="#DBFFEA" />
        <Rect opacity={0.4} x={40.6807} y={56} width={1.2832} height={24} fill="#DBFFEA" />
        <Rect x={-1} y={45.9688} width={55} height={2.03125} fill={gradientFill7} />
      </G>
      <Defs>
        <LinearGradient
          id={gradientId}
          x1={43.7798}
          y1={51.3526}
          x2={43.7798}
          y2={82.889}
          gradientUnits="userSpaceOnUse">
          <Stop stopColor="#DBFFEA" />
          <Stop offset={1} stopColor="white" />
        </LinearGradient>
        <LinearGradient
          id={gradientId1}
          x1={26.1978}
          y1={51.942}
          x2={26.1978}
          y2={83.4785}
          gradientUnits="userSpaceOnUse">
          <Stop stopColor="#DBFFEA" />
          <Stop offset={1} stopColor="white" />
        </LinearGradient>
        <LinearGradient
          id={gradientId2}
          x1={8.1911}
          y1={52.5315}
          x2={8.1911}
          y2={82.889}
          gradientUnits="userSpaceOnUse">
          <Stop stopColor="#DBFFEA" />
          <Stop offset={1} stopColor="white" />
        </LinearGradient>
        <LinearGradient
          id={gradientId3}
          x1={-0.169489}
          y1={55.9786}
          x2={30.6724}
          y2={35.9396}
          gradientUnits="userSpaceOnUse">
          <Stop stopColor="#DBFFEA" />
          <Stop offset={1} stopColor="white" />
        </LinearGradient>
        <LinearGradient
          id={gradientId4}
          x1={16.3878}
          y1={97.2857}
          x2={45.7977}
          y2={75.0662}
          gradientUnits="userSpaceOnUse">
          <Stop stopColor="#DBFFEA" />
          <Stop offset={1} stopColor="white" />
        </LinearGradient>
        <LinearGradient
          id={gradientId5}
          x1={21.7586}
          y1={90.0625}
          x2={64.7087}
          y2={85.3466}
          gradientUnits="userSpaceOnUse">
          <Stop stopColor="#DBFFEA" />
          <Stop offset={1} stopColor="white" />
        </LinearGradient>
        <RadialGradient
          id={gradientId6}
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(2.15039 34) rotate(90) scale(2.53125)">
          <Stop stopColor="white" />
          <Stop offset={1} stopColor="#DBFFEA" />
        </RadialGradient>
        <LinearGradient
          id={gradientId7}
          x1={26.5}
          y1={45.9688}
          x2={26.5}
          y2={48}
          gradientUnits="userSpaceOnUse">
          <Stop stopColor="#DBFFEA" />
          <Stop offset={1} stopColor="white" />
        </LinearGradient>
        <ClipPath id={clipPathId}>
          <Rect width={156} height={92} fill="white" />
        </ClipPath>
      </Defs>
    </AccessibleSvg>
  )
}
